"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericTableComponent = void 0;
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-loop-func */
/* eslint-disable no-continue */
/* eslint-disable global-require */
const core_1 = require("@angular/core");
const angular_1 = require("angular");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const filtering_1 = require("../shared/services/filtering");
const object_1 = __importDefault(require("../shared/services/object"));
let GenericTableComponent = class GenericTableComponent {
    constructor(filteringService, objectService, tableId) {
        this.filteringService = filteringService;
        this.objectService = objectService;
        this.tableId = tableId;
        this.filters = {};
        this.filterHash = '';
        this.filterCount = 0;
        this.tableData = [];
        this.filteredData = [];
        this.filterTags = [];
        this.showFilter = false;
        this.showMobileFilter = false;
        this.mainFilterMobile = false;
        /** For Server-Side filtering, sorting */
        this.totalCount = 0;
        this.currentPage = 1;
        this.sortDirection = 1;
        this.filterInputSubject = new rxjs_1.Subject();
        this.filterMode = 'CLIENT';
        this.limit = 10;
        this.initialized = false;
        /**
         * Try to load the values of the filters from local storage.
         * To prevent updates in the filter object colliding with the saved copy,
         * the current filters a provided here.
         */
        this.loadFiltersFromStorage = () => {
            const filtersFromStorage = localStorage.getItem(`TableFilter_${this.tableId}`);
            if (filtersFromStorage) {
                const parsedFilters = JSON.parse(filtersFromStorage);
                if (parsedFilters) {
                    for (const [filterKey, filterValue] of Object.entries(this.filters)) {
                        if (parsedFilters[filterKey]) {
                            filterValue.value = parsedFilters[filterKey].value;
                        }
                    }
                }
            }
            this.filterTable();
        };
        this.saveFilterToLocalStorage = () => {
            const filtersToSave = (0, angular_1.copy)(this.filters);
            for (const [filterKey, filterValue] of Object.entries(filtersToSave)) {
                if (!filterValue.value)
                    delete filtersToSave[filterKey];
            }
            localStorage.setItem(`TableFilter_${this.tableId}`, JSON.stringify(filtersToSave));
        };
        /** Here we transform the user input in our own data format `TableFilter`
         * into a mongodb compatible `Filter`. Depending on the type of filter,
         * we need to transform the input to make it work. */
        this.getMongoFilter = () => {
            /** We combine all set filters with an `$and` in the end */
            const andFilters = [];
            this.saveFilterToLocalStorage();
            Object.entries(this.filters).forEach(([index, filter]) => {
                if (!filter.value)
                    return;
                /** If one input is used for multiple queries, the filter will define
                 * multiple traversals through the object. In that case, we will combine all entries
                 * with an $or. */
                let subFilter = {};
                let value = filter.value ? String(filter.value) : filter.value;
                if (filter.fullTraversals) {
                    /** `fullTraversal` defines a complete `Mongodb` `Filter` element, that
                     * the user selects from a multiu select dropdown. It is used for complex
                     * queries that are not possible with the standard filter types.
                     * For example, the user can select multiple options from a dropdown
                     * and we will combine them with an $or.
                     *
                     * The `fullTraversals` object is a key-value pair, where the key is the
                     * name of the traversal and the value is the full `Mongodb` stringified filter. */
                    const selectedKeys = value.split(',');
                    const parsedTraversals = Object.entries(filter.fullTraversals)
                        .filter(([key]) => selectedKeys.includes(key))
                        .map(([, traversal]) => traversal)
                        .map((traversal) => JSON.parse(traversal));
                    subFilter = {
                        $or: parsedTraversals,
                    };
                }
                else if (filter.type === 'DAYS_GREATER' || filter.type === 'DAYS_LESS') {
                    const daysAgo = parseInt(value, 10);
                    const targetDate = new Date();
                    targetDate.setDate(targetDate.getDate() - daysAgo);
                    const orFilters = [];
                    if (typeof filter.traversal === 'string') {
                        filter.traversal = [filter.traversal];
                    }
                    const operator = filter.type === 'DAYS_GREATER' ? '$lt' : '$gt';
                    filter.traversal.forEach((traversal) => {
                        orFilters.push({
                            [traversal]: { $exists: true, [operator]: targetDate },
                        });
                    });
                    subFilter = {
                        $or: orFilters,
                    };
                }
                else if (filter.type === 'ARRAY_LENGTH') {
                    const comparator = filter.comparator || '$eq';
                    let sizeFilter = {};
                    const filterValue = parseInt(String(filter.value), 10);
                    switch (comparator) {
                        case '$eq':
                            sizeFilter = { [filter.traversal]: { $size: filterValue } };
                            break;
                        case '$gt':
                            /** For example: { vehicleData.images.1: { $exists: true } } */
                            sizeFilter = { [`${filter.traversal}.${filterValue}`]: { $exists: true } };
                            break;
                        case '$gte':
                            sizeFilter = { [`${filter.traversal}.${filterValue - 1}`]: { $exists: true } };
                            break;
                        case '$lte':
                            sizeFilter = {
                                $or: [
                                    { [`${filter.traversal}.${filterValue}`]: { $exists: false } },
                                    { [`${filter.traversal}`]: { $exists: false } },
                                ],
                            };
                            break;
                        case '$lt':
                            sizeFilter = {
                                $or: [
                                    { [`${filter.traversal}.${filterValue - 1}`]: { $exists: false } },
                                    { [`${filter.traversal}`]: { $exists: false } },
                                ],
                            };
                            break;
                        default:
                            break;
                    }
                    subFilter = {
                        $and: [
                            // { [filter.traversal as string]: { $exists: true } },
                            // { [filter.traversal as string]: { $type: 4 } },
                            // { $expr: { [comparator]: [{ $size: filter.traversal }, filterValue] } },
                            sizeFilter,
                        ],
                    };
                }
                else if (filter.type === 'NUMBER') {
                    const comparator = filter.comparator || '$eq';
                    if (value.includes(', ')) {
                        value = { $in: value.split(',').map((v) => parseInt(v, 10)) };
                    }
                    else {
                        value = parseInt(String(value), 10);
                    }
                    const orFilters = [];
                    if (typeof filter.traversal === 'string') {
                        filter.traversal = [filter.traversal];
                    }
                    filter.traversal.forEach((traversal) => {
                        orFilters.push({ [traversal]: { [comparator]: value } });
                    });
                    subFilter = {
                        $or: orFilters,
                    };
                }
                else if (filter.type === 'BOOLEAN_OBJECT' && value) {
                    /** Special filter type: 'BOOLEAN_OBJECT'
                     * Value might be: bluetooth, androidAuto
                     * Key would be modelData.infotainment
                     *
                     * We need to transform the input into:
                     * {
                     *  modelData.infotainment.bluetooth: true,
                     *  modelData.infotainment.androidAuto: true,
                     * } */
                    value
                        .split(', ')
                        .forEach((v) => {
                        subFilter[`${filter.traversal}.${v}`] = true;
                    });
                }
                else if (filter.type === 'ARRAY_OBJECT' && value) {
                    /** Special filter: 'ARRAY_OBJECT'.
                     * Value might be 614,250.
                     * Key would be vehicleData.seriesOptions
                     *
                     * Where `seriesOptions` would be an array of objects with key `code`.
                     * We search for all documents where seriesObjects contain an object for each defined value
                     */
                    const filterValues = value.split(',');
                    subFilter = {
                        // eslint-disable-next-line max-len
                        $and: filterValues.map((v) => ({ [filter.traversal]: { $elemMatch: { [filter.objectKey]: v } } })),
                    };
                    // } else if (typeof filter.traversal === 'string') {
                    //   if (value === 'NOT_DEFINED') {
                    //     subFilter = {
                    //       $or: [
                    //         { [filter.traversal as keyof Filter<unknown>]: { $exists: false } },
                    //         { [filter.traversal as keyof Filter<unknown>]: null },
                    //         { [filter.traversal as keyof Filter<unknown>]: false },
                    //       ],
                    //     } as never;
                    //   } else if (value === 'DEFINED') {
                    //     subFilter = {
                    //       $and: [
                    //         { [filter.traversal as keyof Filter<unknown>]: { $exists: true } },
                    //         { [filter.traversal as keyof Filter<unknown>]: { $ne: null } },
                    //         { [filter.traversal as keyof Filter<unknown>]: { $ne: false } },
                    //       ],
                    //     } as never;
                    //   } else {
                    //     subFilter[filter.traversal as keyof Filter<unknown>] = value as never;
                    //   }
                }
                else {
                    /** Here we work with one or more traversals */
                    const traversals = [];
                    if (Array.isArray(filter.traversal)) {
                        traversals.push(...filter.traversal);
                    }
                    else {
                        traversals.push(filter.traversal);
                    }
                    const orFilters = [];
                    traversals.forEach((traversal) => {
                        if (value === 'NOT_DEFINED' || value === 'ALL_UNDEFINED') {
                            orFilters.push({
                                $or: [
                                    { [traversal]: { $exists: false } },
                                    { [traversal]: null },
                                    { [traversal]: false },
                                ],
                            });
                        }
                        else if (value === 'DEFINED') {
                            orFilters.push({
                                $and: [
                                    { [traversal]: { $exists: true } },
                                    { [traversal]: { $ne: null } },
                                    { [traversal]: { $ne: false } },
                                ],
                            });
                        }
                        else {
                            orFilters.push({ [traversal]: value });
                        }
                    });
                    if (value === 'ALL_UNDEFINED') {
                        subFilter = {
                            $and: orFilters,
                        };
                    }
                    else {
                        subFilter = {
                            $or: orFilters,
                        };
                    }
                }
                andFilters.push(subFilter);
            });
            if (!andFilters.length)
                return {};
            console.log({
                $and: andFilters,
            });
            return {
                $and: andFilters,
            };
        };
        this.changeDataLimit = (newLimit) => {
            this.limit = newLimit;
            this.getMongoData();
        };
        this.sortDates = (date0, date1, _row0, _row1, sortDirection) => {
            let placeholderDate = new Date(0);
            if (sortDirection === 'desc') {
                placeholderDate = new Date(8640000000000000);
            }
            const dateA = date0 ? new Date(date0) : placeholderDate;
            const dateB = date1 ? new Date(date1) : placeholderDate;
            return dateB.getTime() - dateA.getTime();
        };
        this.sortPrices = (_value0, _value1, row0, row1, sortDirection) => {
            let placeholderPrice = -9999999;
            if (sortDirection === 'desc') {
                placeholderPrice = 999999;
            }
            let price0 = placeholderPrice;
            let price1 = placeholderPrice;
            if (row0.vehicleData.price.campaignPrice && row0.vehicleData.price.campaignPrice > 0) {
                price0 = row0.vehicleData.price.campaignPrice;
            }
            if (row0.vehicleData.price.onlinePrice && row0.vehicleData.price.onlinePrice > 0) {
                price0 = row0.vehicleData.price.onlinePrice;
            }
            if (row1.vehicleData.price.campaignPrice && row1.vehicleData.price.campaignPrice > 0) {
                price1 = row1.vehicleData.price.campaignPrice;
            }
            if (row1.vehicleData.price.onlinePrice && row1.vehicleData.price.onlinePrice > 0) {
                price1 = row1.vehicleData.price.onlinePrice;
            }
            return price1 - price0;
        };
        this.afterFiltering = () => {
            const query = {};
            Object.keys(this.filters).forEach((key) => {
                const { value, traversal } = this.filters[key];
                if (!value)
                    return;
                query[String(traversal)] = String(value).split(', ');
            });
            this.getTableData(query);
        };
        this.onFilterInput = () => {
            if (!this.initialized)
                return;
            this.currentPage = 1;
            this.filterInputSubject.next();
        };
        /** Triggered by `ngx-datatable` when user sorts by a column */
        this.onSort = (event) => {
            const columnName = event.column.prop;
            const sortDirection = event.newValue;
            this.sortBy = columnName;
            this.sortDirection = sortDirection === 'desc' ? -1 : 1;
            this.getMongoData();
        };
        /** Triggered by `ngx-datatable` when a new page is selected. */
        this.onPageChange = (page) => __awaiter(this, void 0, void 0, function* () {
            if (this.currentPage === page)
                return;
            this.currentPage = page;
            this.getMongoData();
            const mainElement = document.querySelector('main.main');
            if (!mainElement)
                return;
            mainElement.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
            const backdropElement = document.querySelector('html');
            if (!backdropElement)
                return;
            backdropElement.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
        this.filterInputSubject.pipe((0, operators_1.debounceTime)(300)).subscribe(() => {
            this.getMongoData();
            this.generateFilterTags();
        });
    }
    ngAfterViewInit() {
        this.initialized = true;
        this.getMongoData();
    }
    /** Fix for ngx datatable not calculating width correctly on its own. */
    ngAfterViewChecked() {
        window.dispatchEvent(new Event('resize'));
    }
    generateFilterTags() {
        return __awaiter(this, void 0, void 0, function* () {
            this.filterTags = [];
            let id = 0;
            for (const [filterId, filter] of Object.entries(this.filters)) {
                if (!filter.value)
                    continue;
                String(filter.value).replace(/ /g, '').split(',').forEach((filterValue) => __awaiter(this, void 0, void 0, function* () {
                    const value = filterValue;
                    let description = filter.translations ? filter.translations[filterValue] : filterValue;
                    if (filterValue && filter.translationFunction) {
                        description = yield filter.translationFunction(filter.value);
                    }
                    this.filterTags.push({
                        filterId,
                        id,
                        value,
                        description,
                    });
                    id += 1;
                }));
            }
        });
    }
    filterTable() {
        if (this.tableData && this.filterMode === 'CLIENT') {
            this.filteredData = this.filteringService.filterDataset(this.tableData, this.filters);
            this.filterCount = Object
                .values(this.filters)
                .filter((v) => v.value !== undefined && v.value !== '').length;
            this.saveFilterToLocalStorage();
        }
        this.generateFilterTags();
        this.afterFiltering();
    }
    removeFilter(tag) {
        var _a;
        if (!tag) {
            for (const [_, filter] of Object.entries(this.filters)) {
                delete filter.value;
            }
            this.getMongoData();
            this.generateFilterTags();
            this.filterTable();
            return;
        }
        const filter = this.filters[tag.filterId];
        if ((_a = filter.value) === null || _a === void 0 ? void 0 : _a.includes(',')) {
            filter.value = filter.value.replace(/ /g, '').split(',').filter((f) => f !== tag.value).join(', ');
        }
        else {
            delete filter.value;
        }
        this.currentPage = 1;
        this.getMongoData();
        this.generateFilterTags();
        this.filterTable();
    }
};
GenericTableComponent = __decorate([
    (0, core_1.Component)({
        selector: 'table-component',
        template: '<div>Generic Table Component</div>',
    }),
    __param(2, (0, core_1.Inject)(String)),
    __metadata("design:paramtypes", [typeof (_a = typeof filtering_1.FilteringService !== "undefined" && filtering_1.FilteringService) === "function" ? _a : Object, typeof (_b = typeof object_1.default !== "undefined" && object_1.default) === "function" ? _b : Object, String])
], GenericTableComponent);
exports.GenericTableComponent = GenericTableComponent;
